
<div>
  <shopadmin-notice-modal ref="notice"></shopadmin-notice-modal>
  <shopadmin-past-banquet-modal ref="pastBanquet"></shopadmin-past-banquet-modal>
</div>
